module.exports = __webpack_public_path__ + "static/FAQ-team2-17c297b2e42faee732a25a86af1c2f85.jpg";